<template>
  <section>
    <div id="stripe-checkout" class="col-md-6 custom-card-design">
		<v-alert type="success" dismissible v-show="alert_success">
		Your card has been charged successfully.
		</v-alert>
		<v-alert type="error" dismissible v-show="alert_error">
		We were unable to charge your card - please contact support.
		</v-alert>
		<form action="" method="post" id="payment-form">

		<v-text-field
			v-model="charge_amount"
			label="Total to be Billed to your Card"
			type="number"
			step="10"
			prefix="$"
		/>
		<br/>

		<label for="card-element" class="credit-text">
			<label class="currency-text">We accept all major debit/credit cards in 135+ currencies.</label>
		</label>
		<br/>
		<div id="card-element">
			<!-- a Stripe Element will be inserted here. -->
		</div>

		<!-- Used to display Element errors -->
		<div id="card-errors" role="alert"></div>

		<br/>
		<br/>
		<v-btn
			color="success"
			type="submit"
			:loading="pending_card_charge"
			id='submit_payment'
		>Submit Payment</v-btn>
		<br/>
		</form>
	</div>
  </section>
</template>

<script>
var load = require('load-script')

export default {
  props: ['user', 'api_prefix', 'email_address', 'full_name'],
  data: function () {
  return {
    tab: null,
    charge_amount: 10,
    alert_success: false,
    alert_error: false,
    account_balance: null,
    pending_card_charge: false,
    show_checkout: true,
    }
  },
  created: function()
  {
    
  },
  mounted: function()
  {
    let self = this
    window.analytics.page('Fund')
    //self.get_account_balance()
    load('https://js.stripe.com/v3/', function (err, script) 
    {
      if (err) 
      {
        // print useful message
      }
      else 
      {
        self.setup_stripe()
      }
    })
  },
  components: {
    
  },
  computed: {
  },
  methods: {

    async get_account_balance()
    {
      let self = this;
      var response = await self.$http.get(self.api_prefix + '/account_balance',
      {

      });
      if(response.data!=null)
      {
        self.account_balance = response.data
      }
    },
    setup_stripe()
    {
      let self = this;
      var stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
      var elements = stripe.elements();

      var style = {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      var card = elements.create('card', {style: style});

      // Add an instance of the card Element into the `card-element` <div>
      card.mount('#card-element');

      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });

      // Create a token or display an error when the form is submitted.
      var form = document.getElementById('payment-form');
      form.addEventListener('submit', function(event)
      {
        event.preventDefault();

        stripe.createToken(card).then(function(result)
        {
          if (result.error)
          {
            // Inform the customer that there was an error
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
          }
          else
          {
            // Send the token to your server
            self.stripeTokenHandler(result.token);
          }
        });
      });
    },
    async stripeTokenHandler(stripe_token)
    {
      let self = this;

      // Insert the token ID into the form so it gets submitted to the server
      var form = document.getElementById('payment-form');
      var hiddenInput = document.createElement('input');
      hiddenInput.setAttribute('type', 'hidden');
      hiddenInput.setAttribute('name', 'stripeToken');
      hiddenInput.setAttribute('value', stripe_token.id);
      form.appendChild(hiddenInput);

      self.pending_card_charge = true

      try
      {
        var response = await self.$http.post(self.api_prefix + '/process_payment',
        {
          stripe_token: stripe_token,
          charge_amount: self.charge_amount,
          receipt_email: self.email_address,
          full_name: self.full_name
        });
        console.log(response);
        if(response.data==true)
        {
          self.alert_error = false;
          self.alert_success = true;
          self.$emit('funded');
        }
        else
        {
          self.alert_error = true;
          self.alert_success = false;
        }
        self.pending_card_charge = false;
      }
      catch (error)
      {
        console.log(error)
        self.alert_error = true;
        self.alert_success = false;
      }
    },
  }
}
</script>

<style scoped>
#stripe-checkout
{
  border-top: 1px solid black;
  padding-top: 5px;
}

#card-element
{
  width: 100%;
}

.StripeElement {
  background-color: white;
  height: 40px;
  padding: 5px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
